import { Badge } from '@/components/ui/badge';
import { Card } from '@/components/ui/card';
import { Label } from '@/components/ui/label';

const statusToBadge = {
  guardado: 'secondary',
  herdado: 'outline',
  sobreposto: 'default',
};

export const PrintStoredEffectiveComparator = ({ compareData, loading }) => {
  if (loading) {
    return <Card className="px-4 py-6 text-sm text-muted-foreground" data-testid="print-stored-effective-compare-loading">A carregar comparador de presets...</Card>;
  }

  if (!compareData?.preset) return null;

  const locationName = compareData.location?.name || 'Global';

  return (
    <Card className="overflow-hidden" data-testid="print-stored-effective-comparator">
      <div className="border-b bg-slate-50 px-4 py-3">
        <p className="text-sm font-semibold">Comparar `stored vs effective` nos presets</p>
        <p className="text-[11px] text-muted-foreground">Localização em foco: {locationName}. Mostra o guardado, herdado, sobreposto, efectivo e runtime.</p>
      </div>

      <div className="grid gap-3 px-4 py-4 xl:grid-cols-2">
        <div className="rounded-2xl border bg-white p-3" data-testid="print-stored-effective-preset-card">
          <Label className="text-[10px] uppercase tracking-[0.16em] text-muted-foreground">Preset POS</Label>
          <div className="mt-3 space-y-2">
            {compareData.preset.fields.map((field) => (
              <div key={field.field} className="rounded-xl border p-3" data-testid={`print-stored-effective-preset-field-${field.field}`}>
                <div className="flex items-center justify-between gap-2">
                  <p className="text-sm font-medium">{field.label}</p>
                  <Badge variant={statusToBadge[field.status] || 'outline'}>{field.status}</Badge>
                </div>
                <div className="mt-2 grid gap-1 text-[11px] text-muted-foreground md:grid-cols-4">
                  <p><span className="font-medium">Stored:</span> {String(field.stored_global ?? '—')}</p>
                  <p><span className="font-medium">Local:</span> {String(field.stored_location ?? '—')}</p>
                  <p><span className="font-medium">Effective:</span> {String(field.effective ?? '—')}</p>
                  <p><span className="font-medium">Runtime:</span> {String(field.runtime ?? '—')}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-2xl border bg-white p-3" data-testid="print-stored-effective-banking-card">
          <Label className="text-[10px] uppercase tracking-[0.16em] text-muted-foreground">Bancário / herança</Label>
          <div className="mt-3 space-y-2">
            {compareData.banking.fields.map((field) => (
              <div key={field.field} className="rounded-xl border p-3" data-testid={`print-stored-effective-banking-field-${field.field}`}>
                <div className="flex items-center justify-between gap-2">
                  <p className="text-sm font-medium">{field.label}</p>
                  <Badge variant={statusToBadge[field.status] || 'outline'}>{field.status}</Badge>
                </div>
                <div className="mt-2 grid gap-1 text-[11px] text-muted-foreground md:grid-cols-4">
                  <p><span className="font-medium">Stored:</span> {String(field.stored_global ?? '—')}</p>
                  <p><span className="font-medium">Local:</span> {String(field.stored_location ?? '—')}</p>
                  <p><span className="font-medium">Effective:</span> {String(field.effective ?? '—')}</p>
                  <p><span className="font-medium">Runtime:</span> {String(field.runtime ?? '—')}</p>
                </div>
              </div>
            ))}
            <div className="rounded-xl border p-3 text-[11px] text-muted-foreground" data-testid="print-stored-effective-banks-summary">
              <p><span className="font-medium">Bancos extra globais:</span> {(compareData.banking.additional_banks?.stored_global || []).length}</p>
              <p><span className="font-medium">Bancos extra locais:</span> {(compareData.banking.additional_banks?.stored_location || []).length}</p>
              <p><span className="font-medium">Bancos extra efectivos:</span> {(compareData.banking.additional_banks?.effective || []).length}</p>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};